import React from 'react';
import cn from 'classnames';

import styles from './buttons.module.css';

type ButtonBaseProps = {
  id?: string;
  children?: string;
  className?: string;
  onClick?: () => void;
  disabled?: boolean;
  type?: 'button' | 'submit';
};

const ButtonBase: React.FC<ButtonBaseProps> = ({
  id,
  className = styles.btn,
  children = '',
  onClick,
  disabled = false,
  type = 'button',
}) => (
  <input
    id={id}
    type={type}
    disabled={disabled}
    className={cn(styles.btn, className)}
    onClick={() => {
      onClick && onClick();
    }}
    value={children}
  />
);

type ButtonProps = {
  id?: string;
  children?: string;
  onClick?: () => void;
  disabled?: boolean;
  type?: 'button' | 'submit';
  className?: string;
};

const ButtonDefault: React.FC<ButtonProps> = (props) => (
  <ButtonBase {...props} className={cn(styles.btnDefault)} />
);

export const ButtonPrimary: React.FC<ButtonProps> = (props) => {
  return <ButtonBase {...props} className={cn(styles.btnPrimary)} />;
};

export default ButtonDefault;